/**
 * @description Resolve the profile Role label from company RBAC, not Wristband.
 *
 * @dependencies
 * - GET /api/auth/me companies[].roleName (employee_roles.name)
 *
 * @notes
 * - users.role is the platform role (merchant | so | superadmin | customer).
 *   The merchant profile must never display "Merchant" for that field.
 * - Company assignment is Admin / Manager / Employee on employee_roles.
 * - SO / Super Admin users on /so/profile may have no employee role; keep a
 *   platform fallback so the field is not blank. merchant has no fallback.
 */

const PLATFORM_ROLE_FALLBACK = {
  so: 'Sales Organization',
  superadmin: 'Super Admin'
};

/**
 * @param {object} params
 * @param {Array<{id?: string, roleName?: string|null}>} [params.companies]
 * @param {string|null} [params.activeCompanyId]
 * @param {string|null} [params.platformRole] users.role
 * @returns {string|null} Display label, or null when nothing to show
 */
export function resolveProfileRoleDisplay({
  companies = [],
  activeCompanyId = null,
  platformRole = null
} = {}) {
  const list = Array.isArray(companies) ? companies : [];
  const active =
    list.find((company) => company?.id && company.id === activeCompanyId) || list[0];

  if (active?.roleName) {
    return active.roleName;
  }

  if (platformRole && PLATFORM_ROLE_FALLBACK[platformRole]) {
    return PLATFORM_ROLE_FALLBACK[platformRole];
  }

  if (active) {
    return 'Employee';
  }

  return null;
}
